import type { AppRoute } from 'src/routes/types';

import Iconify from 'src/legacy/components/iconify/Iconify';
import SvgColor from 'src/legacy/components/svg-color';
import {
  CLIENTS,
  CUSTOMERS,
  PLACEMENTS,
  USERS,
} from 'src/legacy/routes/consts';
import { PATH_DASHBOARD } from 'src/legacy/routes/paths';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ height: 1, width: 1 }}
  />
);

const ICONS = {
  accessibilityNew: <Iconify icon="material-symbols:accessibility-new" />,
  analytics: icon('ic_analytics'),
  business: <Iconify icon="mdi:business" />,
  dashboard: icon('ic_dashboard'),
  ecommerce: icon('ic_ecommerce'),
  familyRestroom: <Iconify icon="material-symbols:family-restroom" />,
  file: icon('ic_file'),
  house: <Iconify icon="material-symbols:house" />,
  nightShelter: <Iconify icon="material-symbols:night-shelter" />,
  user: icon('ic_user'),
};

const navConfig = (privateAppRoutes: AppRoute[]) => {
  const legacyNavConfig = [
    {
      items: [
        {
          icon: ICONS.house,
          path: PATH_DASHBOARD.home,
          title: 'home',
        },
      ],
      subheader: '',
    },
    /**
     * PROFILES
     */
    {
      items: [
        {
          icon: ICONS.familyRestroom,
          path: PATH_DASHBOARD.fosterFamily.root,
          title: 'foster_families',
        },
        {
          icon: ICONS.accessibilityNew,
          path: PATH_DASHBOARD.client.root,
          title: CLIENTS,
        },
        {
          icon: ICONS.business,
          path: PATH_DASHBOARD.customer.root,
          title: CUSTOMERS,
        },
      ],
      subheader: 'profiles',
    },

    // ----------------------------------------------------------------------

    /**
     * TOOLS
     */
    {
      items: [
        {
          icon: ICONS.nightShelter,
          path: PATH_DASHBOARD.placement.root,
          title: PLACEMENTS,
        },
      ],
      subheader: 'tools',
    },

    // ----------------------------------------------------------------------

    /**
     * MANAGEMENT
     */
    {
      items: [
        {
          icon: ICONS.user,
          isAdmin: true,
          path: PATH_DASHBOARD.user.root,
          title: USERS,
        },
      ],
      subheader: 'management',
    },

    // ----------------------------------------------------------------------
  ];

  // TODO: Remove when we get rid of all legacy code
  // Inject new app routes into legacy nav config
  privateAppRoutes.forEach((route) => {
    if (!route.menu) return;
    const group = legacyNavConfig.find(
      (group) => group.subheader === route.menu?.group
    );
    if (group) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      group.items.push({
        icon: route.menu.icon,
        isAdmin: route.permission === 'admin',
        path: route.path,
        title: route.menu.title(),
      });
    }
  });

  return legacyNavConfig;
};

export default navConfig;
